import {
  type CorridorQuotePushPublic,
  ErpCorridorRelayService,
} from "@common/client"
import { makeAxiosMutation, makeNoArgsQuery, makeQuery } from "./utils"

const ACTIVE_PUSH_POLL_MS = 5000

export const corridorRelayKey = ["corridor-relay"] as const

export const corridorQuotePushesBaseKey = ["corridor-quote-pushes"] as const

export const corridorQuotePushesKey = (quoteId: string) =>
  [...corridorQuotePushesBaseKey, quoteId] as const

export function isActivePush(push: CorridorQuotePushPublic): boolean {
  return push.status === "queued" || push.status === "running"
}

export const corridorRelayQuery = makeNoArgsQuery({
  serviceCall: ErpCorridorRelayService.getCorridorRelay,
  queryKey: corridorRelayKey,
})

export const useSetCorridorRelayMutation = makeAxiosMutation({
  serviceCall: ErpCorridorRelayService.setCorridorRelay,
  invalidates: () => [corridorRelayKey, corridorQuotePushesBaseKey],
})

export const useClearCorridorRelayMutation = makeAxiosMutation({
  serviceCall: ErpCorridorRelayService.clearCorridorRelay,
  invalidates: () => [corridorRelayKey, corridorQuotePushesBaseKey],
})

export const corridorQuotePushesQuery = makeQuery({
  serviceCall: ErpCorridorRelayService.listCorridorQuotePushes,
  queryKey: ({ quote_id }) => corridorQuotePushesKey(quote_id),
  refetchInterval: (query) =>
    query.state.data?.data.some(isActivePush) ? ACTIVE_PUSH_POLL_MS : false,
})

export const useCreateCorridorQuotePushMutation = makeAxiosMutation({
  serviceCall: ErpCorridorRelayService.createCorridorQuotePush,
  invalidates: ({ corridorQuotePushCreate }) => [
    corridorQuotePushesKey(corridorQuotePushCreate.quote_id),
  ],
})

export const useRetryCorridorQuotePushMutation = makeAxiosMutation({
  serviceCall: ErpCorridorRelayService.retryCorridorQuotePush,
  invalidates: (_input, push) => [corridorQuotePushesKey(push.quote_id)],
})
